import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  computed,
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  BackendErrorEntity,
  OfflineSaleItemEntity
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiOfflineSaleDetail = (
    offlineSaleId: MaybeRef<string | undefined | null>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      offlineSaleId = unref(offlineSaleId);
      
      return fetchApiInstance<OfflineSaleItemEntity>(
      {url: `/offlineSales/${offlineSaleId}/detail`, method: 'GET'
    },
      options);
    }
  

export const getApiOfflineSaleDetailQueryKey = (offlineSaleId: MaybeRef<string | undefined | null>,) => {
    return ['offlineSales',offlineSaleId,'detail'] as const;
    }

    
export const getApiOfflineSaleDetailQueryOptions = <TData = Awaited<ReturnType<typeof apiOfflineSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(offlineSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiOfflineSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiOfflineSaleDetailQueryKey(offlineSaleId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiOfflineSaleDetail>>> = () => apiOfflineSaleDetail(offlineSaleId, requestOptions);

      

      

   return  { queryKey, queryFn, enabled: computed(() => !!(unref(offlineSaleId))), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiOfflineSaleDetail>>, TError, TData> 
}

export type ApiOfflineSaleDetailQueryResult = NonNullable<Awaited<ReturnType<typeof apiOfflineSaleDetail>>>
export type ApiOfflineSaleDetailQueryError = ErrorType<BackendErrorEntity>



export function useApiOfflineSaleDetail<TData = Awaited<ReturnType<typeof apiOfflineSaleDetail>>, TError = ErrorType<BackendErrorEntity>>(
 offlineSaleId: MaybeRef<string | undefined | null>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiOfflineSaleDetail>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiOfflineSaleDetailQueryOptions(offlineSaleId,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



